import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import injectStylesheet, { createUseStyles } from 'react-jss';

import { PODCAST_TEASER_TITLE } from 'globalConst/const';
import { DisplayLayout } from 'components/Collection/Collection.const';
import CollectionContext from 'components/Collection/CollectionContext';

import OnDemandTile from 'components/Tiles/OnDemandTile';
import { Podcast } from 'api/models';
import styles from './PodcastLatestEpisode.styles';

interface PodcastLatestEpisodeProps {
  episodes: Array<
    Podcast & {
      progress: {
        completed: boolean;
      };
    }
  >;
  setUpcomingTracks: (track: unknown) => void;
}
const useStyles = createUseStyles(styles, { name: 'PodcastLatestEpisode' });

function PodcastLatestEpisode({ episodes, setUpcomingTracks }: PodcastLatestEpisodeProps): JSX.Element {
  const classes = useStyles();

  const handleOndemandStart = useCallback(() => {
    const upcomingTracks = episodes.slice(1).filter(({ progress }) => !progress || progress.completed === false);
    setUpcomingTracks(upcomingTracks || null);
  }, [episodes, setUpcomingTracks]);

  if (!episodes || !episodes.length) return null;

  // TODO move props to component after OnDemandTile is ts
  const onDemandTileProps = {
    ...episodes[0],
    display: DisplayLayout.LIST,
    collectionTitle: PODCAST_TEASER_TITLE,
    onOndemandStart: handleOndemandStart,
  };

  return (
    <CollectionContext.Provider
      value={{
        showNowPlayingInfo: false,
        isPodcastPage: true,
        isInSearch: false,
        recentSearch: false,
        isInFold: false,
        withFold: false,
      }}
    >
      <div data-testid="podcast_latest_episode" className={classes.container}>
        <h3 className={classes.title}>{PODCAST_TEASER_TITLE}</h3>
        <OnDemandTile {...onDemandTileProps} />
      </div>
    </CollectionContext.Provider>
  );
}

PodcastLatestEpisode.defaultProps = {
  episodes: null,
};

PodcastLatestEpisode.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectStylesheet(styles)(PodcastLatestEpisode);
